module.exports = __webpack_public_path__ + "42b8ce9ae99181fb98322b4112b8c21b.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-60.png
// module id = 136
// module chunks = 0